/* eslint-disable no-undef */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { applyMiddleware, compose, createStore } from 'redux';
import { Provider } from 'react-redux';
import { logger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { RecoilRoot } from 'recoil/dist';
import reducers from './redux/reducers';
import sagas from './redux/sagas';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './i18n';

const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const routeMiddleware = routerMiddleware(history);
const middleware = [sagaMiddleware, routeMiddleware];
if (process.env.NODE_ENV === 'development') {
  // middleware.push(logger);
}

const store = createStore(
  reducers(history),
  compose(applyMiddleware(...middleware))
);
sagaMiddleware.run(sagas);

ReactDOM.render(
  <RecoilRoot>
    <Provider store={store}>
      <Suspense fallback="loading...">
        <App history={history} />
      </Suspense>
    </Provider>
  </RecoilRoot>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
export { history };
